import { ballArr, count, singleDouble, singleDoubleCnname, smallBig, smallBigCnname, dragonTiger, fishCnname } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

let treePk10Children = index => {
  return [
    {
      align: 'center',
      title: '单',
      render: (h, { row }) => <span>{row[index] ? row[index].single : 0}</span>
    },
    {
      align: 'center',
      title: '双',
      render: (h, { row }) => <span>{row[index] ? row[index].double : 0}</span>
    },
    {
      align: 'center',
      title: '大',
      render: (h, { row }) => <span>{row[index] ? row[index].big : 0}</span>
    },
    {
      align: 'center',
      title: '小',
      render: (h, { row }) => <span>{row[index] ? row[index].small : 0}</span>
    }
  ];
};

const pk10 = Vue => {
  let list = Vue => {
    let hasBallOpacity = (x, xIndex, data, dataIndex) => {
      let resClass = '';
      if (Vue.selectType === 0) {
        resClass += !~Vue.selectNumArr.indexOf(x) ? ' opacity' : '';
      }
      if (Vue.selectType === 1) {
        resClass += (Vue.selectValue != singleDouble(x)) != 0 ? ' opacity' : '';
      }
      if (Vue.selectType === 2) {
        resClass += (Vue.selectValue != smallBig(x, 9)) == 0 ? ' opacity' : '';
      }
      if (Vue.selectType === 3) {
        let lastStr = data[dataIndex - 1] ? data[dataIndex - 1].resultStr : '';
        let nextStr = data[dataIndex + 1] ? data[dataIndex + 1].resultStr : '';
        let lastArr = ballArr(lastStr);
        let nextArr = ballArr(nextStr);

        if (lastArr[xIndex] === x || nextArr[xIndex] === x) {
        } else {
          resClass += ' opacity';
        }
      }
      return resClass;
    };
    return [
      {
        title: '时间',
        align: 'center',
        width: 220,
        render: (h, { row }) => {
          return <span>{dayjs(row.resultDate).format('YYYY-MM-DD HH:mm:ss')}</span>;
        }
      },
      {
        title: '期数',
        align: 'center',
        key: 'issueId'
      },
      {
        renderHeader: (h, params) => {
          return (
            <div class="showBallHandle">
              <span on-click={_ => (Vue.tableShowBallType = 0)} class={Vue.tableShowBallType == 0 && 'active'}>
                显示号码
              </span>
              <span on-click={_ => (Vue.tableShowBallType = 1)} class={Vue.tableShowBallType == 1 && 'active'}>
                显示大小
              </span>
              <span on-click={_ => (Vue.tableShowBallType = 2)} class={Vue.tableShowBallType == 2 && 'active'}>
                显示单双
              </span>
            </div>
          );
        },
        width: 484,
        align: 'center',
        render: (h, { row, index }) => {
          let arr = ballArr(row.resultStr);
          let boxClassName = 'ball';
          if (Vue.tableShowBallType == 0) {
            boxClassName += ' cars';
            arr = arr.map((x, i) => {
              let className = `car${x}`;
              className += hasBallOpacity(x, i, Vue.dataSource, index);
              return { value: '', className };
            });
          }
          if (Vue.tableShowBallType == 1) {
            boxClassName += ' smallBig';
            arr = arr.map((x, i) => {
              let className = smallBig(x, 9) == 0 ? 'small' : 'big';
              className += hasBallOpacity(x, i, Vue.dataSource, index);
              return { value: '', className };
            });
          }
          if (Vue.tableShowBallType == 2) {
            boxClassName += ' singleDouble';
            arr = arr.map((x, i) => {
              let className = singleDouble(x) == 0 ? 'single' : 'double';
              className += hasBallOpacity(x, i, Vue.dataSource, index);
              return { value: '', className };
            });
          }

          return (
            <div class={boxClassName}>
              {arr.map((x, i) => {
                return (
                  <span class={x.className} key={i}>
                    {x.value}
                  </span>
                );
              })}
            </div>
          );
        }
      },
      {
        title: '冠亚和',
        align: 'center',
        width: 135,
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          return (
            <div class="insideTableTd">
              <p class="count brr">{count([arr[0], arr[1]])}</p>
              <p class="smallBig brr">{smallBig(count([arr[0], arr[1]]), 22) == 0 ? <span class="blue">小</span> : <span class="red">大</span>}</p>
              <p class="singleDouble">{singleDouble(count([arr[0], arr[1]])) == 0 ? <span class="blue">单</span> : <span class="red">双</span>}</p>
            </div>
          );
        }
      },
      {
        title: '1-5龙虎',
        align: 'center',
        width: 220,
        render: (h, { row }) => {
          let arr = ballArr(row.resultStr);
          return (
            <div class="insideTableTd">
              {arr.map((x, i) => {
                if (i < 5) {
                  if (dragonTiger(x, arr[9 - i]) == 0) {
                    return <p class="red brr">龙</p>;
                  } else if (dragonTiger(x, arr[9 - i]) == 1) {
                    return <p class="blue brr">虎</p>;
                  } else {
                    return <p class="green">和</p>;
                  }
                }
              })}
            </div>
          );
        }
      }
    ];
  };

  let doubleStatisColumns1 = [
    {
      align: 'center',
      title: '名次/大小单双',
      key: 'title',
      width: 100
    },
    {
      align: 'center',
      title: '冠军',
      children: treePk10Children(0)
    },
    {
      align: 'center',
      title: '亚军',
      children: treePk10Children(1)
    },
    {
      align: 'center',
      title: '第三名',
      children: treePk10Children(2)
    },
    {
      align: 'center',
      title: '第四名',
      children: treePk10Children(3)
    },
    {
      align: 'center',
      title: '第五名',
      children: treePk10Children(4)
    },
    {
      align: 'center',
      title: '第六名',
      children: treePk10Children(5)
    },
    {
      align: 'center',
      title: '第七名',
      children: treePk10Children(6)
    },
    {
      align: 'center',
      title: '第八名',
      children: treePk10Children(7)
    },
    {
      align: 'center',
      title: '第九名',
      children: treePk10Children(8)
    },
    {
      align: 'center',
      title: '第十名',
      children: treePk10Children(9)
    }
  ];

  let doubleStatisColumns2 = [
    {
      title: '冠亚/龙虎',
      align: 'center',
      key: 'title'
    },
    {
      title: '冠亚和',
      align: 'center',
      children: [
        {
          align: 'center',
          title: '单',
          render: (h, { row }) => <span>{row['gyh'].single}</span>
        },
        {
          align: 'center',
          title: '双',
          render: (h, { row }) => <span>{row['gyh'].double}</span>
        },
        {
          align: 'center',
          title: '大',
          render: (h, { row }) => <span>{row['gyh'].big}</span>
        },
        {
          align: 'center',
          title: '小',
          render: (h, { row }) => <span>{row['gyh'].small}</span>
        }
      ]
    },
    {
      align: 'center',
      title: '第一名龙虎',
      children: [
        {
          align: 'center',
          title: '龙',
          render: (h, { row }) => <span>{row[0].dragon}</span>
        },
        {
          align: 'center',
          title: '虎',
          render: (h, { row }) => <span>{row[0].tiger}</span>
        }
      ]
    },
    {
      title: '第二名龙虎',
      align: 'center',
      children: [
        {
          align: 'center',
          title: '龙',
          render: (h, { row }) => <span>{row[1].dragon}</span>
        },
        {
          align: 'center',
          title: '虎',
          render: (h, { row }) => <span>{row[1].tiger}</span>
        }
      ]
    },
    {
      align: 'center',
      title: '第三名龙虎',
      children: [
        {
          align: 'center',
          title: '龙',
          render: (h, { row }) => <span>{row[2].dragon}</span>
        },
        {
          align: 'center',
          title: '虎',
          render: (h, { row }) => <span>{row[2].tiger}</span>
        }
      ]
    },
    {
      align: 'center',
      title: '第四名龙虎',
      children: [
        {
          align: 'center',
          title: '龙',
          render: (h, { row }) => <span>{row[3].dragon}</span>
        },
        {
          align: 'center',
          title: '虎',
          render: (h, { row }) => <span>{row[3].tiger}</span>
        }
      ]
    },
    {
      align: 'center',
      title: '第五名龙虎',
      children: [
        {
          align: 'center',
          title: '龙',
          render: (h, { row }) => <span>{row[4].dragon}</span>
        },
        {
          align: 'center',
          title: '虎',
          render: (h, { row }) => <span>{row[4].tiger}</span>
        }
      ]
    }
  ];
  return { list, doubleStatisColumns1, doubleStatisColumns2 };
};
export default pk10;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jibenzoushi/columns/pk10.js